import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { requestProducto } from "../../actions/producto";
import {
  requestPresupuestoAdd,
  addProductFalse,
} from "../../actions/presupuesto";
import {
  postAgregarFavoritos,
  postEliminarFavoritos,
  getEsFavorito,
} from "../../actions/favoritos";
import { useFormik } from "formik";
import CardProduct from "./cardProduct";
import ProductoSinImagen from "../../assets/images/ProductoSinImagen.png";
import Dolar from "../../common/dolar";
import rutas from "../../routes/constants/routes";
import { Link } from "react-router-dom";
import colores from "../../shared/constants/styles";
import { Button } from "@material-ui/core";
import { isAllowed } from "../../shared/utils/permissions";
import MyUserService from "../../services/myUser";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { IconButton, Tooltip } from "@mui/material";
import {
  requestDownloadFile,
  closeDownloadFile,
  requestConsultarDisponibilidad,
} from "../../actions/producto";
import "./producto.css";
import AlertaFamilia from "./popUpAlertaFamilia";
import CalendarLogo from "../../assets/icons/calendar.svg";
import { Alert } from "@mui/material";
import ConsultarDisponibilidad from "./popUpConsultarDispo";

const Producto = (props) => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const { id } = useParams();

  const { esFavorito: esFavoritoStore, loading } = useSelector(
    (state) => state.favoritos,
  );
  const [esFavoritoLocal, setEsFavoritoLocal] = useState(false);

  useEffect(() => {
    setEsFavoritoLocal(esFavoritoStore);
  }, [esFavoritoStore]);

  useEffect(() => {
    if (myUser?.clienteId && myUser?.contactoId) {
      dispatch(getEsFavorito(myUser.clienteId.trim(), myUser.contactoId, id));
    }
  }, []);

  const handleToggleFavorito = () => {
    const request = {
      clienteId: myUser.clienteId,
      contactoid: myUser.contactoId,
      productoId: id,
    };
    if (esFavoritoLocal) {
      setEsFavoritoLocal(false);
      dispatch(postEliminarFavoritos(request));
    } else {
      setEsFavoritoLocal(true);
      dispatch(postAgregarFavoritos(request));
    }
  };

  var clienteSeleccionado = JSON.parse(
    window.localStorage.getItem("selectedClient"),
  );

  const myUser = MyUserService.getMyUser();
  const grupoId = MyUserService.getMyGroup();
  const paramsList = MyUserService.getMyUser().paramsList;
  const producto = props.producto;
  const showLargo = producto?.unidadMedida?.metroLineal ? true : false;
  const showAncho = producto?.unidadMedida?.metroCuadrado ? true : false;
  const [selectedImage, setselectedImage] = React.useState(null);
  var cantMin = producto?.cantMin ? producto?.cantMin : 1;
  var largoMin = producto?.largoMin ?? 1;
  var largoMax = producto?.largoMax ?? Infinity;
  var largoproducto = producto?.largo ? producto?.largo : 0;
  var largoSugerido = producto?.largoSugerido;
  var espesor = producto?.espesor;
  var espesorSugerido = producto?.espesorSugerido;

  var productsSuggestion = [];
  producto?.productSuggestions?.$values?.filter((e, i) => {
    if (i < 5) {
      productsSuggestion.push(e);
    }
  });
  if (producto?.unidadMedida !== null) {
    if (showAncho) {
      cantMin =
        paramsList?.$values?.find(
          (p) => p.nombre.trim() === "ProductoCantidadMinimaMC",
        ).numero ?? cantMin;
    }
  }

  const [openConsultarDisponibilidad, setOpenConsultarDisponibilidad] =
    React.useState(false);
  const [openAlertaFamilia, setOpenAlertaFamilia] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [newProducto, setNewProducto] = React.useState();
  const [errorCantidad, setErrorCantidad] = React.useState(false);
  const handleCloseDialog = () => setOpenAlertaFamilia(false);
  const handleConfirmDialog = () => {
    setOpenAlertaFamilia(false);
    if (props.producto.consDispo) {
      setOpenConsultarDisponibilidad(true);
    } else {
      props.requestPresupuestoAdd(newProducto);
    }
  };

  const handleConfirmConsultarDisponibilidad = () => {
    setOpenConsultarDisponibilidad(false);
    props.requestPresupuestoAdd(newProducto);
  };

  useEffect(() => {
    if (isAllowed([18, 40, 28])) {
      dispatch(requestProducto(id, myUser.clienteId));
      dispatch(addProductFalse());
    }
  }, [id]);

  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (props.enviado) setOpen(true);
  }, [props.enviado]);

  useEffect(() => {
    if (props.file !== "" && props.successDownload === true) {
      dispatch(closeDownloadFile());
      const link = document.createElement("a");
      link.target = "_blank";
      link.download = `manual-${props.producto?.grupoProducto?.id}`;
      link.href = URL.createObjectURL(props.file);
      link.click();
    }
  }, [props.file, props.successDownload]);

  useEffect(() => {
    if (props.success) {
      // if (props.success && props.presupuesto && !props.presupuesto.tieneStock) {
      setOpen(true);
      setShowError(false);
    } else {
      if (props.error) setShowError(true);
    }
  }, [props, props.error]);

  const handleConsultarDisponibilidad = () => {
    dispatch(
      requestConsultarDisponibilidad(
        id,
        myUser.clienteId,
        formik.values.cantidad,
      ),
    );
  };

  const formik = useFormik({
    initialValues: {
      productoId: producto.id,
      clienteId: myUser.clienteId,
      contactoId: myUser.contactoId,
      sellerId: myUser.sellerId,
      cantidad: cantMin,
      showLargo: showLargo,
      largo: showLargo ? largoMin : 0,
      showAncho: showAncho,
      ancho: showAncho ? largoMin : 0,
      precio: producto?.precio,
      peso: producto?.peso,
      monedaId: producto?.moneda?.id,
      userId: myUser.userId,
      tipoRol: myUser.tipoRol,
    },
    enableReinitialize: true,
    onSubmit: (addProducto) => {
      setShowError(false);
      let validate = false;
      if (addProducto.largo > 0 && addProducto.largo < largoMin)
        validate = true;
      if (addProducto.largo > largoMax) validate = true;
      if (addProducto.cantidad < cantMin) validate = true;
      if (largoSugerido && largoproducto > 0 && largoproducto !== largoSugerido)
        validate = true;
      if (espesorSugerido && espesor && espesor !== espesorSugerido)
        validate = true;

      if (validate && props.producto.showAlerta) {
        setOpenAlertaFamilia(true);
        setNewProducto(addProducto);
      } else {
        if (props.producto.consDispo) {
          setOpenConsultarDisponibilidad(true);
          setNewProducto(addProducto);
        } else {
          if (addProducto.cantidad <= 0) {
            setErrorCantidad(true);
            return;
          } else {
            props.requestPresupuestoAdd(addProducto);
          }
        }
      }
    },
  });

  const history = useHistory();

  const handleDownload = async (grupoId) =>
    dispatch(requestDownloadFile(grupoId));

  const handleClickSeguirComprando = () => {
    history.push(rutas.PRODUCTOS + "/" + grupoId);
  };

  return (
    <div
      style={{
        backgroundColor: colores.grisClaro,
        overflow: "hidden",
        clear: "both",
      }}
    >
      <Dolar></Dolar>
      <div className="d-flex justify-content-center">
        <hr style={{ width: "90%", color: "black" }}></hr>
      </div>
      <div
        className="container-fluid"
        style={{
          backgroundColor: "white",
          width: "100%",
          overflow: "hidden",
          clear: "both",
        }}
      >
        <div className="row">
          <div className="col-12 col-sm-3 col-md-3 col-lg-3">
            <div
              className="d-flex align-items-start flex-column"
              style={{ overflowY: "scroll", maxHeight: 700 }}
            >
              {producto?.images?.$values?.map((imagen) => (
                <div
                  id={imagen.value}
                  className="card text-center"
                  style={{
                    width: "10rem",
                    marginBlock: "2rem",
                    marginInline: "auto",
                    border: "none",
                  }}
                >
                  <img
                    src={imagen}
                    className="card-img-top"
                    style={{ border: "1px solid black", borderRadius: "7px" }}
                    alt="Imagen del producto"
                    type="button"
                    onClick={() => setselectedImage(imagen)}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="col-12 col-sm-4 col-md-4 col-lg-4">
            <div>
              {producto?.images?.$values[0] ? (
                <img
                  className="img-fluid"
                  style={{ margin: "2rem 0rem" }}
                  src={
                    selectedImage ? selectedImage : producto?.images?.$values[0]
                  }
                  alt=""
                />
              ) : (
                <img
                  className="img-fluid"
                  style={{ margin: "2rem 0rem" }}
                  src={ProductoSinImagen}
                  alt="Producto sin imagen"
                />
              )}
            </div>
          </div>

          <div
            className="col-12 col-sm-4 col-md-4 col-lg-4"
            style={{ margin: "2rem 0rem" }}
          >
            <div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <p style={{ fontSize: "1.8rem", fontWeight: "500", margin: 0 }}>
                  {producto?.descripcion}
                </p>
                <Tooltip
                  title={
                    esFavoritoLocal
                      ? "Quitar de favoritos"
                      : "Agregar a favoritos"
                  }
                >
                  <IconButton
                    onClick={handleToggleFavorito}
                    style={{ padding: "4px", flexShrink: 0 }}
                  >
                    {esFavoritoLocal ? (
                      <FavoriteIcon style={{ color: "#c0392b" }} />
                    ) : (
                      <FavoriteBorderIcon style={{ color: "#c0392b" }} />
                    )}
                  </IconButton>
                </Tooltip>
              </div>

              <p className="producto__text-code" style={{ fontSize: "0.9rem" }}>
                Código de producto:{" "}
                <span className="fw-bolder">{producto?.id}</span>
              </p>
              <div className="separator"></div>
              <h1 className="fw-bolder" style={{ fontSize: "1.9rem" }}>
                <strong>
                  {producto?.moneda?.simbolo} {producto?.precio}
                </strong>
              </h1>
              <p>
                Peso: <span className="fw-bolder">{producto?.peso} kg</span>
              </p>
              {espesor > 0 && (
                <p>
                  Espesor: <span className="fw-bolder">{espesor}</span>
                </p>
              )}
              {largoproducto > 0 && (
                <p>
                  Largo: <span className="fw-bolder">{largoproducto}</span>
                </p>
              )}
              <p>
                Categoría:{" "}
                <span className="fw-bolder">{producto?.grupoDescripcion}</span>
              </p>
              {producto?.grupoDescripcion === "Herramientas" && (
                <p>
                  <span className="fw-bolder" style={{ fontSize: "0.8125rem" }}>
                    (La disponibilidad de los productos solicitados en el
                    presupuesto están sujetos a verificación de stock)
                  </span>
                </p>
              )}
              <div>
                <img
                  src={CalendarLogo}
                  alt="Calendar.svg"
                  className="producto__icon-stock"
                />
                <p className="producto__text-stock">
                  En caso de no haber stock inmediato en el punto de Pick Up, el
                  producto estará disponible en 4 días hábiles
                </p>
              </div>
              <div>
                <form onSubmit={formik.handleSubmit}>
                  <div className="d-flex" style={{ margin: "1rem 0rem" }}>
                    {showLargo && (
                      <div
                        style={{
                          marginRight: "1rem",
                          width: "5rem",
                          Height: "2.125rem",
                        }}
                      >
                        <label for="largo" className="form-label fw-bolder">
                          LARGO
                        </label>
                        <input
                          type="number"
                          step=".001"
                          class="form-control"
                          id="largo"
                          name="largo"
                          value={formik.values.largo}
                          onChange={formik.handleChange}
                          error={formik.errors.largo}
                          style={{ border: "1px solid black", width: "12vh" }}
                        />
                      </div>
                    )}
                    {showAncho && (
                      <div
                        style={{
                          marginRight: "1rem",
                          width: "5rem",
                          Height: "2.125rem",
                        }}
                      >
                        <label for="ancho" className="form-label fw-bolder">
                          ANCHO
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          id="ancho"
                          name="ancho"
                          value={formik.values.ancho}
                          onChange={formik.handleChange}
                          error={formik.errors.ancho}
                          style={{ border: "1px solid black", width: "12vh" }}
                        />
                      </div>
                    )}
                  </div>
                  {formik.errors.largo && formik.touched.largo && (
                    <div className="text-danger">{formik.errors.largo}</div>
                  )}
                  {formik.errors.ancho && formik.touched.ancho && (
                    <div className="text-danger">{formik.errors.ancho}</div>
                  )}
                  <div className="separator"></div>
                  <div className="producto__btn-qty">
                    <label for="ancho" className="form-label fw-bolder">
                      CANTIDAD
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      id="cantidad"
                      name="cantidad"
                      value={formik.values.cantidad}
                      onChange={formik.handleChange}
                      error={formik.errors.cantidad}
                      style={{ border: "1px solid black", width: "12vh" }}
                    />
                  </div>
                  {errorCantidad && (
                    <div className="text-danger" style={{ marginTop: 20 }}>
                      La cantidad debe ser mayor a 0
                    </div>
                  )}
                  {isAllowed(14) && isAllowed(16) ? (
                    props.productos === true ? (
                      <div>
                        <Button
                          className="my-3"
                          style={{
                            backgroundColor: "#cc615a",
                            color: "#fff",
                            "margin-top": "15px !important",
                          }}
                          variant="contained"
                          disabled={true}
                          type="submit"
                        >
                          CARGANDO...
                        </Button>
                      </div>
                    ) : (
                      <div style={{ marginTop: 15 }}>
                        <Button
                          className="my-3 producto__btn-add"
                          variant="contained"
                          type="submit"
                        >
                          AGREGAR A CARRITO
                        </Button>
                        <Button
                          class="btn btn-outline-success my-3"
                          style={{ textTransform: "uppercase", marginLeft: 10 }}
                          variant="contained"
                          onClick={handleClickSeguirComprando}
                        >
                          SEGUIR COMPRANDO
                        </Button>
                      </div>
                    )
                  ) : null}
                  {formik.errors.cantidad && formik.touched.cantidad ? (
                    <div className="text-danger">{formik.errors.cantidad}</div>
                  ) : (
                    ""
                  )}
                  {isAllowed(14) && isAllowed(16) && (
                    <div>
                      <div style={{ paddingTop: "1rem" }}>
                        <Link
                          to={rutas.CARRITO}
                          style={{ color: colores.rojo }}
                        >
                          <b>Ver carrito</b>
                        </Link>
                      </div>
                    </div>
                  )}
                  {props.success && (
                    // props.presupuesto &&
                    // props.presupuesto.tieneStock &&
                    <div
                      className="alert alert-success text-center"
                      style={{ width: "17.5rem", marginTop: 10 }}
                      role="alert"
                    >
                      <p style={{ margin: 0, padding: 0 }}>
                        Producto agregado al carrito <CheckCircleOutlineIcon />
                      </p>
                    </div>
                  )}
                  {showError && (
                    <Alert style={{ textAlign: "center" }} severity="error">
                      {props?.error}
                    </Alert>
                  )}
                </form>
              </div>
              {isAllowed(6) && productsSuggestion.length > 0 && (
                <div>
                  <div
                    className="d-flex justify-content-start"
                    style={{ margin: "1rem 0rem", marginTop: "2rem" }}
                  >
                    <p
                      className="fw-bolder"
                      style={{
                        marginRight: "0.700rem",
                        backgroundColor: "#FFFF00",
                        fontSize: "1rem",
                        padding: "5px",
                      }}
                    >
                      PRODUCTOS <b>SUGERIDOS</b>
                    </p>
                  </div>
                  <div
                    className="d-flex justify-content-start overflow-auto"
                    style={{
                      margin: "0.5rem 0rem",
                      width: "auto",
                      overflowY: "hidden",
                    }}
                  >
                    {productsSuggestion?.map((sugerido) => (
                      <CardProduct key={sugerido.id} data={sugerido} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <hr
            style={{
              width: "80%",
              border: "1px solid black",
              color: "black",
              margin: "2rem 0rem",
            }}
          ></hr>
        </div>
        <div className="container" style={{ width: "60%" }}>
          <div className="row">
            <div className="col-12">
              <h5 className="fw-bolder">DESCRIPCIÓN</h5>
              <p className="fw-bolder">{producto?.grupoDetalle}</p>
            </div>
            <div className="col-12">
              <Button
                onClick={() =>
                  handleDownload(props.producto?.grupoProducto?.id)
                }
                style={{ textDecoration: "none", color: "red" }}
              >
                DESCARGAR MANUAL DE USUARIO
              </Button>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <hr
            style={{
              width: "80%",
              border: "1px solid black",
              color: "black",
              margin: "4rem 0rem",
            }}
          ></hr>
        </div>
      </div>
      <AlertaFamilia
        open={openAlertaFamilia}
        handleClose={handleCloseDialog}
        handleConfirm={handleConfirmDialog}
        cantidad={formik.values.cantidad}
        espesor={espesor}
        largo={formik.values.largo}
        ancho={formik.values.ancho}
        cantMin={cantMin}
        espesorSugerido={espesorSugerido}
        largoMin={largoMin}
        largoMax={largoMax}
        largoSugerido={largoSugerido}
        largoproducto={largoproducto}
      />

      <ConsultarDisponibilidad
        producto={producto?.descripcion}
        open={openConsultarDisponibilidad}
        handleConfirm={handleConfirmConsultarDisponibilidad}
      />
    </div>
  );
};

export default connect(
  (state) => ({
    producto: state.producto.producto,
    loading: state.presupuestos.loading,
    error: state.presupuestos.errorMsj,
    success: state.presupuestos.success,
    // presupuesto: state.presupuestos.presupuesto,
    file: state.producto.file,
    successDownload: state.producto.successDownload,
    enviado: state.producto.enviado,
  }),
  (dispatch) => ({
    requestProducto: (id, clienteId) =>
      dispatch(requestProducto(id, clienteId)),
    requestPresupuestoAdd: (addProducto) =>
      dispatch(requestPresupuestoAdd(addProducto)),
    addProductFalse: (id) => dispatch(addProductFalse()),
    requestDownloadFile: (grupoId) => dispatch(requestDownloadFile(grupoId)),
    requestConsultarDisponibilidad: (id, clienteId) =>
      dispatch(requestConsultarDisponibilidad(id, clienteId)),
  }),
)(Producto);
